// extracted by mini-css-extract-plugin
export var author = "index-module--author--3d3ff";
export var avatar = "index-module--avatar--c5a3d";
export var date = "index-module--date--becb2";
export var root = "index-module--root--7294b";